<div class="dialog-container text-center">
  <h2 matDialogTitle class="visually-hidden">
    {{ (title || message) | translate }}
  </h2>
  <div class="header-wrapper">
    @if (title) {
    <span class="dark font-bold font-20">{{ title | translate }}</span>
    }
    <div class="icon-wrapper" matDialogClose>
      <i class="bi bi-x-lg"></i>
    </div>
  </div>
  <div class="content-wrapper">
    @if (image) {
    <div class="mb-3">
      <img
        [src]="'../../../../assets/images/' + image"
        alt="{{ 'Actions-List.Delete' | translate }}" />
    </div>
    } @if (message) {
    <span class="font-bold dark font-18">{{message | translate}}</span>
    } @if (subMessage) {
    <span class="mt-2 light font-14"> {{ subMessage | translate }}</span>
    }
  </div>
  <div class="footer-wrapper">
    <button class="default" matDialogClose>
      {{ "Actions-List.Close" | translate }}
    </button>
  </div>
</div>
